import Axios from 'axios';

import { GetConfigUtil } from '~/shared/utils/envUtil';

import { CaWiseHotelReservation } from './types';

/**
 * tour、hotel共通のhash化処理
 * @param reservationId 予約id
 * @param status ステータス。tour、hotel共に1固定
 * @param amount 合計料金
 */
export const fetchHash = async (
  reservationId: string,
  status: number,
  amount: number
) => {
  const result = await Axios.get(
    `${
      GetConfigUtil.getPublicStaticConfig().CRYPTO.HASH_URL
    }?id=${reservationId}&status=${status.toString()}&amount=${amount.toString()}`
  );

  return result.data;
};

export const encryptTourData = async (data: object) => {
  return encrypt(JSON.stringify(data));
};

export const encryptHotelData = async (data: CaWiseHotelReservation) => {
  const dataList: string[] = [
    data.productId,
    data.productName,
    data.checkInDate,
    data.checkOutDate,
    data.numberOfPeople.toString(),
    data.numberOfAdultMen?.toString() ?? '',
    data.numberOfAdultWomen?.toString() ?? '',
    data.numberOfChildren.toString(),
    data.repeatUserFlag?.toString() ?? '',
    data.paymentFlag?.toString() ?? '',
    data.amount.toString(),
    data.facilityCode,
    data.facilityName,
    data.areaCode,
    data.areaName,
    data.roomNumber ?? '',
    data.meal?.toString() ?? '',
    data.currencyType,
    data.exchangeRate.toString(),
  ];
  return encrypt(dataList.join('##'));
};

/**
 * サーバに暗号化を依頼する。アルゴリズムはHotelとTourで TODO:
 */
const encrypt = async (data: string) => {
  const result = await Axios.get(
    `${
      GetConfigUtil.getPublicStaticConfig().CRYPTO.ENCRIPT_URL
    }?data=${encodeURIComponent(data)}`
  );

  return result.data;
};
